// Module
var code = `<iframe src="{{\$ctrl.smartSalesUrl}}" id="blip-ai" name="blip-ai" width="100%" height="100%" scrolling="no" ng-onload="\$ctrl.onIframeLoad()" frameborder="0" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe> `;
// Exports
module.exports = code;